import { Send } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

/**
 * Voltar da tela de lançar com produto no carrinho que não foi enviado
 * (dono, 25/09/2026): antes o carrinho sumia sem aviso. Enviar agora abre a
 * conferência de sempre; Sair sem enviar descarta só o carrinho (as
 * informações da mesa ficam salvas).
 */
export default function SairSemEnviarDialog({ aberto, quantidade, onEnviar, onSair, onContinuar }) {
  return (
    <Dialog open={aberto} onOpenChange={(v) => { if (!v) onContinuar(); }}>
      <DialogContent className="sm:max-w-sm" data-e2e="sair-sem-enviar">
        <DialogTitle>Produtos não enviados</DialogTitle>
        <DialogDescription>
          Você tem {quantidade} {quantidade === 1 ? "produto" : "produtos"} no carrinho que ainda não
          {quantidade === 1 ? " foi enviado" : " foram enviados"} para a cozinha.
        </DialogDescription>
        <div className="flex flex-col gap-2 mt-1">
          <Button className="h-11 font-bold bg-orange-500 hover:bg-orange-600 text-white" onClick={onEnviar} data-e2e="sair-enviar-agora">
            <Send className="w-4 h-4 mr-2" /> Enviar agora
          </Button>
          <Button variant="outline" className="h-11 text-red-600 border-red-300 hover:bg-red-50 dark:hover:bg-red-500/10" onClick={onSair} data-e2e="sair-sem-enviar-ok">
            Sair sem enviar
          </Button>
          <Button variant="ghost" className="h-10" onClick={onContinuar} data-e2e="sair-continuar">
            Continuar lançando
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
